// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609180450/js/" + chunkId + "." + {"44":"57628072","225":"17d25cc3","481":"854ad4e6","486":"9fee1314","770":"7f76873b"}[chunkId] + ".0.642209642893203.chunk.js";
};